export default "__VITE_ASSET__BzBNX4NJ__"